import React, {useState} from "react";
import {InputLabel} from "@mui/material";
import SelectAllSearch from "../Select/SelectAllSearch";
import useManufacturerData from "../useManufacturerData/useManufacturerData";
import {setSelectedManufacturersData} from "../../reducers/UserReducer/UserActions";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";

const ManufacturerSelect = ({ align = "end" } ) => {
	const dispatch = useDispatch();
	const { hasMultipleManufacturers, manufacturersOptionsMap } = useManufacturerData();
	const selectedManufacturers = useSelector(({user}) => user.selectedManufacturers);
	const [ manufacturers, setManufacturers ] = useState(selectedManufacturers ?? []);

	if (!hasMultipleManufacturers) return null;

	const handleSelectManufacturer = (value) => {
		setManufacturers(value);
	};

	const onApplySearch = () => {
		if (manufacturers?.length > 0) {
			dispatch(setSelectedManufacturersData(manufacturers));
		} else {
			toast.warn('Please select at least one manufacturer');
		}
	}

	const alignedClass = align === "end" ? "justify-content-end" : "justify-content-start";

	return (
		<div className={`w-100 d-flex align-items-center ${alignedClass}`}>
			<div style={{width: '300px'}}>
				<InputLabel style={{color: 'black', fontSize: '12px'}}>Select Manufacturer</InputLabel>
				<SelectAllSearch
					isMulti
					hasApply
					name='category'
					options = {manufacturersOptionsMap}
					onChange = {handleSelectManufacturer}
					onApplySearch={() => onApplySearch()}
					value = {manufacturers}
					placeholder='Filter By Manufacturer'
				/>
			</div>
		</div>
	)
}

export default ManufacturerSelect;
